import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  overflow: hidden;
`;

export const Menu = styled.div`
  min-width: 260px;
  display: flex;
`;

export const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const Main = styled.div`
  padding: 0 30px;
  margin-top: 70px;
`;

export const AlignVerticalBetween = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100vh;
`;
